export default "__VITE_ASSET__fd72d44f__"